import { LogoProps, LogoType } from '../../types/logo';

const Logo: LogoType = ({ children, classes = '' }: LogoProps) => {
    return <picture className={classes}>{children}</picture>;
};
export default Logo;
